import React, { ReactNode } from 'react';
import { useQuery } from '@common/hooks';
import { ErrorHandler, LoadingState } from '@common/components';
import {
  CurrentEntityContextQuery,
  CurrentEntityContextQueryResponse,
  CurrentEntityType,
} from '@institutions/graphql';

export const CurrentEntityContext =
  React.createContext<CurrentEntityType | null>(null);

export const CurrentEntityContextProvider = ({
  children,
}: {
  children: ReactNode | undefined;
}) => {
  const { data, loading, error } = useQuery<CurrentEntityContextQueryResponse>(
    CurrentEntityContextQuery,
    {
      fetchPolicy: 'cache-first',
    }
  );

  if (loading) {
    return <LoadingState />;
  }

  if (error || !data?.currentEntity) {
    return <ErrorHandler error={error} log="CurrentEntityContextProvider" />;
  }

  return (
    <CurrentEntityContext.Provider value={data.currentEntity}>
      {children}
    </CurrentEntityContext.Provider>
  );
};
